import React, { useRef, useEffect } from 'react';
import { Box, TextField, InputLabel } from '@mui/material';
import { SearchFieldProps } from '../types';
import { createStyles } from '../utils/styles';
import { useTheme, useMediaQuery } from '@mui/material';

export const SearchField: React.FC<SearchFieldProps> = ({
  id,
  label,
  value,
  onChange,
  onEnterPress,
  onShiftEnterPress,
  placeholder,
  autoFocus,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const styles = createStyles({ isMobile, theme });
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autoFocus]);

  return (
    <Box sx={styles.inputBox}>
      <InputLabel
        htmlFor={id}
        sx={styles.label}
      >
        {label}
      </InputLabel>
      <TextField
        id={id}
        inputRef={inputRef}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            if (e.shiftKey && onShiftEnterPress) {
              onShiftEnterPress();
            } else {
              onEnterPress();
            }
          }
        }}
        placeholder={placeholder}
        fullWidth
        size="small"
        variant="outlined"
        sx={styles.textField}
      />
    </Box>
  );
};
